import { NgModule } from '@angular/core';

import { PhonePipe } from './pipes/phone.pipe';

@NgModule({
  declarations: [PhonePipe],
  imports: [],
  exports: [PhonePipe],
})
export class SharedPhoneModule {}
